/* eslint-disable react/prop-types */
import classes from "./composed-view-header.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classNames from "classnames";
function ComposedViewHeader({ header, title, subTitle, className }) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="center"
      className={classNames(classes.container, className)}
    >
      {header && (
        <Label
          tag="h5"
          weight="bold"
          color="secondary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}
      <Label
        tag="h1"
        weight="bold"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>
      {subTitle && (
        <Label
          tag="h6"
          weight="bold"
          color="secondary"
          className={classes.subTitle}
        >
          {subTitle}
        </Label>
      )}
    </Flex>
  );
}

export default ComposedViewHeader;
